<div
  class="l_flexbar center-item"
  *ngIf="updateButtonStates | async as buttonStates"
>
  <div class="grid__col-12">
    <div class="l_flex guts-m-h-5">
      <div class="l_flex-grow">
        <button
          *ngIf="buttonStates.previousButton"
          df-button
          dfButtonType="passive"
          class="m-full-width m-guts-m-b-half"
          data-dgat="onboardingFooter-a43"
          (click)="onPrevButton(buttonStates.currentStep, buttonStates)"
        >
          {{ buttonStates.previousButton }}
        </button>
      </div>
      <div>
        <button
          *ngIf="buttonStates.skipButton"
          df-button
          dfButtonType="secondary"
          (click)="onSkipButton(buttonStates.currentStep, buttonStates)"
          class="m-full-width m-guts-m-b-half guts-m-r-1"
          data-dgat="onboardingFooter-da2"
        >
          {{ buttonStates.skipButton }}
        </button>
        <span
          class="par--light_a guts-p-r-2"
          *ngIf="buttonStates.disabledStatus"
        >
          {{ buttonStates.disabledStatus }}
        </span>
        <button
          *ngIf="buttonStates.nextButton"
          df-button
          dfButtonType="primary"
          [class.is_disabled]="buttonStates.disableNextStep"
          [disabled]="buttonStates.disableNextStep"
          (click)="onNextButton(buttonStates.currentStep, buttonStates)"
          class="m-full-width m-guts-m-b-half"
          data-dgat="onboardingFooter-db2"
        >
          {{ buttonStates.nextButton }}
        </button>
      </div>
    </div>
    <div
      class="no-mobile absolute m-rel abs-center m-no-abs-center m-center-text"
      *ngIf="buttonStates.currentStep !== 'welcome'"
    >
      <div class="ib" data-dgat="onboardingFooter-1e1" role="presentation">
        <dgx-tracker
          [trackerSteps]="updateTrackerStates"
          (trackerEvent)="onTrackerClicked($event)"
        ></dgx-tracker>
      </div>
    </div>
  </div>
</div>
